import { compressToEncodedURIComponent } from 'lz-string'

declare global {
  interface Window {
    MazuInvoiceHandoff?: {
      compress: (payload: unknown) => string
    }
  }
}

window.MazuInvoiceHandoff = Object.freeze({
  compress(payload: unknown): string {
    return compressToEncodedURIComponent(JSON.stringify(payload))
  },
})
